import { Label } from '@sainsburys-tech/luna-form'
import { ILabel } from '../../../../../types/ComponentTypes/Components'
import parse from 'html-react-parser'

function LabelComponent({ value, id }: ILabel) {
  return (
    <div>
      <Label id="s-formbuilder-label" htmlFor={id}>{parse(value || '')}</Label>
    </div>
  )
}

export default LabelComponent
